import { Product } from "@thenounproject/lingo-core";
import remove from "lodash/remove";
import createEntityReducer from "../helpers/createEntityReducer";
import { getEntitiesFromAction, mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";
import { deleteProduct } from "@redux/actions/products/useDeleteProduct";
import { fetchProducts } from "@redux/actions/products/useProducts";

export default createEntityReducer<Product>(
  "products",
  queryBuilder => {
    queryBuilder.addCase(deleteProduct.fulfilled, (state, action) => {
      const productId = action.payload.result;
      const { spaceId } = action.meta.arg;
      fetchProducts.getQueryData(state, { spaceId }).forEach(query => {
        if (!query.data) return;
        const removed = remove(query.data.products, id => id === productId);
        query.data.total -= removed.length;
      });
    });
  },
  objectBuilder => {
    objectBuilder.addDefaultCase((state, action) => {
      const products = getEntitiesFromAction<Product>(action, "products");
      return mergeEntitiesIfChanged(state, products, (objValue, srcValue, key) => {
        // Replace `fields` and `variants` wholesale rather than letting lodash merge
        // arrays by index (which would leave removed multiselect values in place).
        if (key === "fields" || key === "variants" || key === "assetUuids")
          return srcValue ?? objValue;
        return undefined;
      });
    });
  }
);
